import React, { FC } from 'react';
import ErrorLoadingDetailProperty from 'components/shared/detail/ErrorLoadingDetailProperty';
import AccordionWidgetEmptyMessage from 'app/modules/posts/components/accordionWidget/AccordionWidgetEmptyMessage';
import { HyperText } from '@kontentino/kontentino-post-previews';
import { PostDetail } from 'types/PostDetail';
import clsx from 'clsx';
import { mergeTailwindClasses } from '@kontentino/ui';
import Skeleton from 'react-loading-skeleton';

type Props = {
  isLoading?: boolean;
  isError?: boolean;
  note?: PostDetail['noteWithMentions'] | string;
  dataCy?: string;
};

const NotesView: FC<Props> = ({ isError, isLoading, note, dataCy }) => {
  const text = typeof note === 'string' ? note : note?.text;
  const mentionedUsers =
    typeof note === 'string' ? undefined : note?.mentionedUsers;

  return (
    <>
      {isLoading && <Skeleton height={60} />}
      {isError && <ErrorLoadingDetailProperty />}
      {!!text && (
        <div
          className="tw-border-l-2 tw-border-orange-100 tw-pl-3 tw-text-md "
          data-cy={dataCy}
        >
          <HyperText
            options={{ mentionedUsers }}
            className={mergeTailwindClasses(
              clsx(
                '[&>a]:tw-whitespace-normal [&>a]:tw-break-all [&>a]:!tw-text-primary-90 [&>strong>a]:!tw-text-primary-100 [&>strong]:tw-font-regular [&>strong]:!tw-text-primary-100',
              ),
            )}
          >
            {text}
          </HyperText>
        </div>
      )}
      {!text && !isLoading && !isError && (
        <AccordionWidgetEmptyMessage variant="notes" />
      )}
    </>
  );
};

export default NotesView;
